module.exports = __webpack_public_path__ + "static/media/reliable-icon.f0bd78d5.svg";